export default __webpack_public_path__ + "36d0ca530cfbe930b97af6d1184d30cd.svg";